import React from 'react';
import ReactDOM from 'react-dom/client';
import Dashboard from './Dashboard';
import reportWebVitals from './reportWebVitals';

import 'mapbox-gl/dist/mapbox-gl.css';
import './index.scss';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Dashboard />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
